// extracted by mini-css-extract-plugin
export var skipAnimation = "_14-0";